import { h } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { effect } from '@preact/signals-core'
import { useDriveStore } from './drive-context.js'

function looksLikeHtml(s) {
  return typeof s === 'string' && /<[a-z][\s\S]*>/i.test(s)
}

export function DriveBreadcrumb() {
  const store = useDriveStore()
  const [crumbs, setCrumbs] = useState(store.breadcrumbs.value)

  useEffect(() => effect(() => {
    setCrumbs(store.breadcrumbs.value || [])
  }), [store])

  function navigate(crumb, isLast) {
    if (isLast || !crumb?.path) return
    store.loadFolder(`${crumb.path}.json`)
    history.pushState({}, '', crumb.path)
  }

  return (
    <nav id="drive-breadcrumb" class="drive-breadcrumb" aria-label="breadcrumb">
      <ol class="breadcrumb mb-0 flex-nowrap overflow-hidden">
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1
          const name = crumb.name ?? ''
          const content = looksLikeHtml(name)
            ? <span dangerouslySetInnerHTML={{ __html: name }} />
            : name
          return (
            <li
              key={`${crumb.path || crumb.name}-${i}`}
              class={`breadcrumb-item text-truncate${isLast ? ' active' : ''}`}
              aria-current={isLast ? 'page' : undefined}
            >
              {isLast ? content : (
                <a href={crumb.path || '#'} onClick={(e) => { e.preventDefault(); navigate(crumb, false) }}>
                  {content}
                </a>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
